(ns renolit-roofing-service.shared.util.time
  (:require [cljc.java-time.day-of-week :as jt.day-of-week]
            [cljc.java-time.duration :as jt.duration]
            [cljc.java-time.format.date-time-formatter :as jt.formatter]
            [cljc.java-time.instant :as jt.instant]
            [cljc.java-time.local-date :as jt.local-date]
            [cljc.java-time.local-time :as jt.local-time]
            [cljc.java-time.zone-id :as jt.zone-id]
            [cljc.java-time.zoned-date-time :as jt.zdt]
            [clojure.string :as str]))

(defn at-midnight
  [zoned-date-time]
  (-> zoned-date-time
      (jt.zdt/with-hour 0)
      (jt.zdt/with-minute 0)
      (jt.zdt/with-second 0)
      (jt.zdt/with-nano 0)))

(defn before-midnight
  [zoned-date-time]
  (-> zoned-date-time
      (jt.zdt/with-hour 23)
      (jt.zdt/with-minute 59)
      (jt.zdt/with-second 59)
      (jt.zdt/with-nano 0)))

(defn within-today?
  [zoned-date-time]
  (let [today (jt.instant/at-zone (jt.instant/now)
                                  (jt.zone-id/system-default))
        today-at-midnight (at-midnight today)
        today-before-midnight (before-midnight today)]
    (and (or (jt.zdt/is-after zoned-date-time today-at-midnight)
             (jt.zdt/is-equal zoned-date-time today-at-midnight))
         (or (jt.zdt/is-before zoned-date-time today-before-midnight)
             (jt.zdt/is-equal zoned-date-time today-before-midnight)))))

(defn within-this-week?
  [zoned-date-time]
  (let [today (jt.instant/at-zone (jt.instant/now)
                                  (jt.zone-id/system-default))
        number-of-week-days (jt.day-of-week/get-value (jt.zdt/get-day-of-week today))
        first-day-of-this-week (-> today
                                   (jt.zdt/minus-days number-of-week-days)
                                   (at-midnight))
        last-day-of-this-week (-> first-day-of-this-week
                                  (jt.zdt/plus-days 6)
                                  (before-midnight))]
    (and (or (jt.zdt/is-after zoned-date-time first-day-of-this-week)
             (jt.zdt/is-equal zoned-date-time first-day-of-this-week))
         (or (jt.zdt/is-before zoned-date-time last-day-of-this-week)
             (jt.zdt/is-equal zoned-date-time last-day-of-this-week)))))

(defn instant->zoned-date-time-string
  [instant {:keys [format-pattern zone-id]
            :or {format-pattern "yyyy-MM-dd HH:dd"
                 zone-id (jt.zone-id/system-default)}}]
  (let [formatter (jt.formatter/of-pattern format-pattern)
        zoned-date-time (jt.instant/at-zone instant zone-id)]
    (jt.formatter/format formatter zoned-date-time)))

(defn parse-local-time
  [local-time-str {:keys [format-pattern]
                   :or {format-pattern "H:mm"}}]
  (try
    (let [formatter (jt.formatter/of-pattern format-pattern)]
      (jt.local-time/parse local-time-str formatter))
    #?(:clj
       (catch Exception _
         nil)
       :cljs
       (catch js/Error _
         nil))))

(defn format-local-time
  [local-time {:keys [format-pattern]
               :or {format-pattern "H:mm"}}]
  (when local-time
    (let [formatter (jt.formatter/of-pattern format-pattern)]
      (jt.formatter/format formatter local-time))))

(defn parse-local-date
  [local-date-str {:keys [format-pattern]
                   :or {format-pattern "dd/MM/yyyy"}}]
  (try
    (let [formatter (jt.formatter/of-pattern format-pattern)]
      (jt.local-date/parse local-date-str formatter))
    #?(:clj
       (catch Exception _
         nil)
       :cljs
       (catch js/Error _
         nil))))

(defn format-local-date
  [local-date {:keys [format-pattern]
               :or {format-pattern "dd/MM/yyyy"}}]
  (when local-date
    (let [formatter (jt.formatter/of-pattern format-pattern)]
      (jt.formatter/format formatter local-date))))

(defn format-date
  "Format a date value (LocalDate, Instant, or string) as dd/MM/yyyy string."
  [date {:keys [format-pattern zone-id input-pattern]
         :or {format-pattern "dd/MM/yyyy"
              zone-id (jt.zone-id/system-default)}}]
  (when date
    (let [formatter (jt.formatter/of-pattern format-pattern)]
      (cond
        (string? date)
        (let [parsed (parse-local-date date (if input-pattern
                                              {:format-pattern input-pattern}
                                              {}))]
          (when parsed
            (jt.formatter/format formatter parsed)))

        #?@(:cljs [(instance? js/Date date)
                   (let [instant (jt.instant/of-epoch-milli (.getTime date))
                         zdt (jt.instant/at-zone instant zone-id)]
                     (jt.formatter/format formatter zdt))])

        (instance? #?(:clj java.time.Instant :cljs js/java.time.Instant) date)
        (let [zdt (jt.instant/at-zone date zone-id)]
          (jt.formatter/format formatter zdt))

        :else
        (jt.formatter/format formatter date)))))

(defn build-duration-string
  [start end]
  (let [duration (jt.duration/between start end)
        days (jt.duration/to-days duration)
        hours (mod (jt.duration/to-hours duration) 24)
        minutes (mod (jt.duration/to-minutes duration) 60)
        seconds (mod (jt.duration/get-seconds duration) 60)]
    (->>
     (cond-> []
       (> days 0)
       (conj (str days "d"))

       (> hours 0)
       (conj (str hours "h"))

       (> minutes 0)
       (conj (str minutes "m"))

       (> seconds 0)
       (conj (str seconds "s")))
     (str/join " "))))
